// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bolivia from '../_raw/flag/icon_flag_bolivia.png';

export default () => <img src={Bolivia} alt="Bolivia" />;
